import { jobList, jobPaymentDetails } from "constants/job";
const initialState = {
  jobList: {},
  jobPaymentDetails: {},
};

const job = (state = initialState, action) => {
  switch (action.type) {
    case jobList:
      return { ...state, jobList: action.payload };
    case jobPaymentDetails:
      return { ...state, jobPaymentDetails: action.payload };
    default:
      return state;
  }
};

export default job;